import React from 'react'

const SvgOfficeChair = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M7.82 3.801A2 2 0 019.81 2h4.38a2 2 0 011.99 1.801l.6 5A2 2 0 0114.79 11H13v2h2.068C18 13 18 16 17 16h-4v2.5l3.242.81a1 1 0 01.758.97V21a1 1 0 11-2 0l-2-.5v.5a1 1 0 11-2 0v-.5L9 21a1 1 0 11-2 0v-.72a1 1 0 01.757-.97L11 18.5V16H7c-1 0-1-3 1.931-3H11v-2H9.21a2 2 0 01-1.99-2.199l.6-5z' />
  </svg>
)

export default SvgOfficeChair
